module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_c('div', {
    staticClass: "component-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.base.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.base.subtitle))])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "component-body with-padding"
  }, [_c('div', {
    staticClass: "grid-goods out-padding",
    class: _vm.config.style === 'grids' ? 'three-inrow' : 'two-inrow'
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "grid-item"
    }, [_c('div', {
      staticClass: "goods-wrap"
    }, [_c('div', {
      staticClass: "thumbnail"
    }, [_c('img', {
      staticClass: "goods-img",
      attrs: {
        "src": _vm.wximageurl + item.imgUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [(_vm.config.brand && _vm.config.style !== 'grids') ? _c('img', {
      staticClass: "goods-brand",
      attrs: {
        "src": item.brand ? _vm.wximageurl + item.brand : 'https://fakeimg.pl/60x60/EFEFEF/CCC/?text=brand&font=lobster'
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "goods-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (_vm.config.showPrice) ? _c('div', {
      staticClass: "price"
    }, [_c('span', {
      staticClass: "cur"
    }, [_vm._v("¥")]), _vm._v(_vm._s(item.price / 100))]) : _vm._e()])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-more"
  }, [_c('div', {
    staticClass: "three-dot"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16ed7012", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16ed7012"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/goods_grid.vue
// module id = 2494
// module chunks = 0